import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { TagGroupApiModel } from './tag-group-api.model';
import { NeptuneApi } from '../genericApi/neptune.api';

@Injectable()
export class TagGroupsApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}


    /**
     * Gets all the available tag groups
     */
    public getList(): Observable<TagGroupApiModel[]> {
        return this.neptuneApi.api<TagGroupApiModel[]>(
            '/tag-groups',
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * Creates a new tag group
     */
    public create(tagGroup: TagGroupApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/tag-groups',
            tagGroup,
            HttpVerbsEnum.POST
        );
    }

    /**
     * Updates a tag group
     */
    public update(tagGroup: TagGroupApiModel): Observable<null> {
        return this.neptuneApi.api<null>(
            `/tag-groups/${tagGroup.id}`,
            tagGroup,
            HttpVerbsEnum.PUT
        );
    }

    /**
     * Deletes a tag group
     */
    public delete(tagGroup: TagGroupApiModel): Observable<null> {
        return this.neptuneApi.api<null>(
            `/tag-groups/${tagGroup.id}`,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
